import React from "react";
import PropTypes from "prop-types";
import { translate, Responsive } from "admin-on-rest";

const styles = {
  title: {
    fontSize: "0.750em",
    flexDirection: "row",
    display: "flex"
  },
  iconStyles: {
    margin: 6,
    textAlign: "center"
  }
};

const Icon = source => {
  if (source === "categories") {
    return (
      <span style={styles.iconStyles}>
        <i className="material-icons">&#xE896;</i>
      </span>
    );
  } else if (source === "collections") {
    return (
      <span style={styles.iconStyles}>
        <i className="material-icons">&#xE8F0;</i>
      </span>
    );
  } else if (source === "marketers") {
    return (
      <span style={styles.iconStyles}>
        <i className="material-icons">&#xE7EF;</i>
      </span>
    );
  } else if (source === "pages") {
    return (
      <span style={styles.iconStyles}>
        <i className="material-icons">&#xE873;</i>
      </span>
    );
  } else if (source === "products") {
    return (
      <span style={styles.iconStyles}>
        <i className="material-icons">&#xE156;</i>
      </span>
    );
  } else if (source === "transfers") {
    return (
      <span style={styles.iconStyles}>
        <i className="material-icons">&#xE3E7;</i>
      </span>
    );
  } else if (source === "ticket") {
    return (
      <span style={styles.iconStyles}>
        <i className="material-icons">&#xE53F;</i>
      </span>
    );
  } else if (source === "calendar") {
    return (
      <span style={styles.iconStyles}>
        <i className="material-icons">&#xE878;</i>
      </span>
    );
  } else if (source === "payments") {
    return (
      <span style={styles.iconStyles}>
        <i className="material-icons">&#xE227;</i>
      </span>
    );
  } else if (source === "sim") {
    return (
      <span style={styles.iconStyles}>
        <i className="material-icons">&#xE0D4;</i>
      </span>
    );
  } else if (source === "activation") {
    return (
      <span style={styles.iconStyles}>
        <i className="material-icons">&#xE8AC;</i>
      </span>
    );
  } else if (source === "agency") {
    return (
      <span style={styles.iconStyles}>
        <i className="material-icons">&#xE896;</i>
      </span>
    );
  } else {
    return (
      <span style={styles.iconStyles}>
        <i className="material-icons">&#xE896;</i>
      </span>
    );
  }
};
const IconTitle = translate(({ icon, title, translate, isTranlate }) => {
  let translateTitle = title;
  if (isTranlate) {
    translateTitle = translate(title, { smart_count: 2 });
  }
  return (
    <Responsive
      small={<span style={styles.title}>{translateTitle}</span>}
      medium={
        <span style={styles.title}>
          {" "}
          {Icon(icon)} {translateTitle}
        </span>
      }
    />
  );
});

IconTitle.propTypes = {
  basePath: PropTypes.string,
  isTranlate: PropTypes.bool
};

IconTitle.defaultProps = {
  style: { padding: 0 },
  isTranlate: true
};

export default IconTitle;



// WEBPACK FOOTER //
// ./src/components/icon_title/index.js